'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchInoutsIfNeeded = exports.failureInouts = exports.receiveInouts = exports.requestInouts = exports.invalidateInouts = exports.filterInouts = exports.INVALIDATE_INOUT = exports.FILTER_INOUT = exports.FAILURE_INOUT = exports.RECEIVE_INOUT = exports.REQUEST_INOUT = undefined;

var _css = require('antd/lib/notification/style/css');

var _notification = require('antd/lib/notification');

var _notification2 = _interopRequireDefault(_notification);

var _api = require('../api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_INOUT = exports.REQUEST_INOUT = 'REQUEST_INOUT'; /**
                                                              * 交易明细相关Actions
                                                              */
var RECEIVE_INOUT = exports.RECEIVE_INOUT = 'RECEIVE_INOUT';
var FAILURE_INOUT = exports.FAILURE_INOUT = 'FAILURE_INOUT';
var FILTER_INOUT = exports.FILTER_INOUT = 'FILTER_INOUT';
var INVALIDATE_INOUT = exports.INVALIDATE_INOUT = 'INVALIDATE_INOUT';

var filterInouts = exports.filterInouts = function filterInouts(filter) {
    return {
        type: FILTER_INOUT,
        filter: filter
    };
};

var invalidateInouts = exports.invalidateInouts = function invalidateInouts(filter) {
    return {
        type: INVALIDATE_INOUT,
        filter: filter
    };
};

var requestInouts = exports.requestInouts = function requestInouts(filter) {
    return {
        type: REQUEST_INOUT,
        filter: filter
    };
};

var receiveInouts = exports.receiveInouts = function receiveInouts(filter, response) {
    return {
        type: RECEIVE_INOUT,
        filter: filter,
        inouts: response
    };
};
var failureInouts = exports.failureInouts = function failureInouts(error) {
    return {
        type: FAILURE_INOUT,
        error: error
    };
};

var shouldFetchInouts = function shouldFetchInouts(state, filter) {
    var inouts = state.inout.inouts;
    if (inouts.items.length === 0) {
        return true;
    }
    if (inouts.isFetching) {
        return false;
    }
    return true;
};

var fetchInoutsIfNeeded = exports.fetchInoutsIfNeeded = function fetchInoutsIfNeeded(filter, page) {
    return function (dispatch, getState) {
        return (0, _api.fetchInouts)(filter, page).then(function (response) {
            dispatch(receiveInouts(filter, response.data));
        }).catch(function (error) {
            _notification2.default['error']({
                message: '获取失败',
                description: error.response && error.response.data && error.response.data.message
            });
            dispatch(failureInouts(error));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/inout.js
// module id = 888
// module chunks = 0